import {
  AppDefinedVariables,
  Data,
} from "Components/TextContext/textInterfaces";

import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { replaceNumStringVariables } from "Components/TextContext";

export const getProductSpecificComponentText = (
  productName: ProductBackendName,
  components: Data[],
  fieldId: string,
  appDefinedVariables?: AppDefinedVariables,
): string => {
  const componentText = Object.entries(components).reduce((acc, curr) => {
    const component = curr[1];

    const componentNameLevel3 = component.name.split(".")[2].split(/[-_]+/);

    const isProductAndIdPresent = isProductNameAndFieldIdInComponentName(
      productName,
      fieldId,
      componentNameLevel3,
    );

    if (isProductAndIdPresent) {
      acc =
        component.variables !== undefined
          ? replaceNumStringVariables(component, appDefinedVariables)
          : component.text;
    }

    return acc;
  }, "");

  if (componentText === "") {
    throw new Error(
      "Could not find component that matches product and fieldId input.",
    );
  }

  return componentText;
};

const isProductNameAndFieldIdInComponentName = (
  productName: ProductBackendName,
  fieldId: string,
  splitComponentNameLevel3Array: string[],
): boolean => {
  const product = identifyProductName(
    productName,
    splitComponentNameLevel3Array,
  );

  const id = identifyFieldId(fieldId, splitComponentNameLevel3Array);

  return !!(product && id);
};

const identifyProductName = (
  productName: ProductBackendName,
  splitComponentNameLevel3Array: string[],
): string | undefined =>
  splitComponentNameLevel3Array.find((element) => element === productName);

const identifyFieldId = (
  fieldId: string,
  splitComponentNameLevel3Array: string[],
): string | undefined =>
  splitComponentNameLevel3Array.find((element) => element === fieldId);
